module.exports = __webpack_public_path__ + "img/mr.12d28803.jpeg";